// src/utils/campaignTracking.js
// Detects which ad campaign brought the visitor to the site (from the
// URL), and remembers it for the rest of the session so it's still
// available whichever page/form they finally submit on.

const STORAGE_KEY = "sd_active_campaign";
const GOOGLE_ADS_KEY = "sd_google_ads_visit";

// Checked in this order — first one present in the URL wins.
// Recommended: in Meta Ads Manager, set each ad's Website URL tracking
// template to include  utm_campaign={{campaign.name}}
// That's a dynamic parameter, so it auto-fills with the live Facebook
// campaign name on every click — no per-ad manual editing, and it will
// always match a "campaignName" in sellDoCampaigns.js as long as your
// Facebook campaign names match the sheet.
const CAMPAIGN_PARAM_NAMES = ["utm_campaign", "campaign", "srd_campaign"];

export const captureCampaignFromURL = () => {
  try {
    const params = new URLSearchParams(window.location.search);

    // Auto-tagged Google Ads clicks always carry a gclid (or one of its newer
    // variants), even when no readable utm_campaign has been configured.
    const isGoogleAdsClick =
      params.has("gclid") ||
      params.has("gbraid") ||
      params.has("wbraid") ||
      params.get("utm_source")?.toLowerCase() === "google";
    if (isGoogleAdsClick) sessionStorage.setItem(GOOGLE_ADS_KEY, "true");

    for (const key of CAMPAIGN_PARAM_NAMES) {
      const value = params.get(key);
      if (value) {
        // URLSearchParams has already decoded percent escapes and `+` signs.
        sessionStorage.setItem(STORAGE_KEY, value);
        console.log(`📍 Ad campaign captured from URL ("${key}"):`, value);
        return value;
      }
    }
  } catch (e) {
    console.warn("Campaign capture skipped:", e);
  }
  return null;
};

export const getActiveCampaignName = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || null;
  } catch (e) {
    return null;
  }
};

export const isGoogleAdsVisit = () => {
  try {
    return sessionStorage.getItem(GOOGLE_ADS_KEY) === "true";
  } catch (e) {
    return false;
  }
};
